import { render } from "./Textarea.vue?vue&type=template&id=25d1df2c&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=25d1df2c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-25d1df2c"

export default script